import { Component, OnInit, ViewChild } from '@angular/core';
import { Guid } from '../core/guid';
import { TxtAttach } from '../core/txtattach.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { EDictateService } from './e-dictate.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AutofocusDirective } from '../shared/directives/autofocus.directive';

@Component({
  selector: 'app-e-dictate',
  templateUrl: './e-dictate.component.html',
  styleUrls: ['./e-dictate.component.css']
})
export class EDictateComponent implements OnInit {
    @ViewChild('textarea') textareainput;
    message: string;
    isError: boolean;
    isAlert: boolean;
    showLoading: boolean;
    signnewid: Guid;
    signdata: string;
    isWarning: boolean;
    isAlertSuccess: boolean;
    signpadhidden: boolean;
    stringifiedData: any;
    txtattach: TxtAttach;
    isDisabled: boolean = false;
    signaturePad: any;
    dictateForm: FormGroup;
    mandateAll: boolean = true;
    FName: string;
    LName: string;
    isNameEnable: boolean;
    defaultValue: string = null;
    constructor(private EDictateService: EDictateService,
        private route: ActivatedRoute,
        private fb: FormBuilder,
        private router: Router, ) {
        var signImg = ''
        route.params.subscribe(val => {
            let id = (this.route.snapshot.params['signId']) ? this.route.snapshot.params['signId'] : '';
            this.signnewid = id;
        });
    }
    ngOnInit(): void {
        this.isAlertSuccess = false;
        this.signpadhidden = true;
        this.isValidSignature(this.signnewid);
        this.formGroup();
        this.textareainput.nativeElement.focus();

    }

    public ngAfterViewInit(): void {
        this.textareainput.nativeElement.focus();
    }

    textareaData = {
        SignatureID: null,
        TextData:null
    };

    formGroup() {
        this.dictateForm = this.fb.group({
            //firstName: [null, Validators.required],
            //lastName: [null, Validators.required],
            textData: [null, Validators.required]
        });
    }

    handleClear() {
        this.textareainput.nativeElement.value = '';
        this.defaultValue = null;
    }

    isValidSignature(id) {
        if (id != "") {
            this.FName = "",
                this.LName = "";
            this.EDictateService.getisValidSign(id)
                .then(response => {
                    this.signpadhidden = false;
                    this.isNameEnable = false;
                    if (response) {
                        //this.FName = response.FName;
                        //this.LName = response.LName;
                        this.showLoading = true;
                        if (response.IsValid == true) {
                            this.isDisabled = false;
                            if (response.TextData != null) {
                                this.signpadhidden = true;
                                this.isNameEnable = true;
                                this.showAlert("Not Authorized", true, true);
                                console.log("Already Signature Submitted");
                                this.isAlertSuccess = true;
                            }
                           
                        } else {
                            this.invalidResponse();
                            console.log("Time out", response.IsValid);
                        }
                    } else {
                        this.invalidResponse();
                        console.log("Signature ID InValid");
                    }
                }).catch(error => {
                    this.showAlert(error, true);
                    this.showLoading = false;
                });
        } else {
            this.signIDValidate(id);
            console.log("Signature ID InValid in onload");
        }
    }


    signIDValidate(id) {
        if (id == "") {
            this.isDisabled = true;
            this.signpadhidden = false;
            this.isNameEnable = true;
            this.showAlert("Not Authorized", true, true);

        }
    }

    invalidResponse() {
        this.isDisabled = true;
        this.isNameEnable = true;
        this.showAlert("Not Authorized", true, true);
    }

   
    //submitSignature() {
    //    if (!this.isDisabled) {
    //        if (this.signnewid != "") {
    //            if (this.dictateForm.controls['firstName'].value != null && this.dictateForm.controls['lastName'].value) {
    //                if (this.dictateForm.controls['textData'].value == null) {
    //                    this.showAlert("Please enter the text", true, true);
    //                } else {
    //                    // for TextAreaData 
    //                    this.textareaData.SignatureID = this.signnewid;
    //                    this.textareaData.TextData = this.dictateForm.controls['textData'].value;

    //                    this.stringifiedData = JSON.stringify(this.textareaData);
    //                    if ((this.FName && this.FName.toLowerCase().trim()) == (this.dictateForm.controls['firstName'].value).toLowerCase().trim() &&
    //                        (this.LName && this.LName.toLowerCase().trim()) == (this.dictateForm.controls['lastName'].value).toLowerCase().trim()) {
    //                        this.EDictateService.saveSignature(this.stringifiedData)
    //                            .then(response => {
    //                                if (response) {
    //                                    this.signdata = response.toString();
    //                                    this.isAlertSuccess = true;
    //                                    this.signpadhidden = true;
    //                                    this.isNameEnable = true;
    //                                    this.showAlert("Thank You.", false);
    //                                }
    //                            })
    //                            .catch(error => {
    //                                this.showAlert(error, true);
    //                                this.showLoading = false;
    //                            });
    //                    } else {
    //                        this.showAlert("First Name/Last Name doesn't match, Please try again...", true, true);
    //                    }
    //                }
    //            } else {
    //                this.showAlert("Please Enter all the mandatory fields", true, true);
    //            }
    //        } else {
    //            this.signIDValidate(this.signnewid);
    //        }
    //    }
    //}
    submitSignature() {
        if (!this.isDisabled) {
            if (this.signnewid != "") {
                if (this.dictateForm.controls['textData'].value == null) {
                    console.log('if',this.dictateForm.controls['textData'].value);
                        this.showAlert("Please enter the text", true, true);
                    } else {
                        // for TextAreaData 
                    console.log('else', this.dictateForm.controls['textData'].value);

                        this.textareaData.SignatureID = this.signnewid;
                        this.textareaData.TextData = this.dictateForm.controls['textData'].value;

                        this.stringifiedData = JSON.stringify(this.textareaData);
                            this.EDictateService.saveSignature(this.stringifiedData)
                                .then(response => {
                                    if (response) {
                                        this.signdata = response.toString();
                                        this.isAlertSuccess = true;
                                        this.signpadhidden = true;
                                        this.isNameEnable = true;
                                        this.showAlert("Thank You.", false);
                                    }
                                })
                                .catch(error => {
                                    this.showAlert(error, true);
                                    this.showLoading = false;
                                });                       
                    }
               
            } else {
                this.signIDValidate(this.signnewid);
            }
        }
    }
    CloseSuccess() {
        window.close();
    }

    // Show Alert

    showAlert(strMsg: string, isErr: boolean, showWarning: boolean = false) {
        this.isAlert = true;
        this.isError = isErr;
        this.isWarning = showWarning;
        this.message = strMsg;
    }

    // Close Alert

    closeAlert() {
        this.isAlert = false;
    }


}



// WEBPACK FOOTER //
// ./SignClient/app/e-dictate/e-dictate.component.ts